// src/components/CustomDocumentUploaderView.jsx
import React from "react";
import { Box, Typography, Button } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";

export default function CustomDocumentUploaderView({
  module,
  file, // either a URL string or a File object
  onChange, // callback(File) → void
  isEditable, // boolean
}) {
  return (
    <Box marginY={2}>
      <Typography variant="subtitle1">
        {module.label || "Your document"}
      </Typography>

      {file ? (
        typeof file === "string" ? (
          <Button
            variant="text"
            startIcon={<CloudUploadIcon />}
            href={file}
            target="_blank"
            rel="noopener noreferrer"
            sx={{ mb: 1 }}
          >
            {file.split("/").pop()}
          </Button>
        ) : (
          <Typography variant="body2" sx={{ mb: 1 }}>
            📄 {file.name}
          </Typography>
        )
      ) : (
        <Typography variant="caption" color="textSecondary" sx={{ mb: 1 }}>
          No file uploaded
        </Typography>
      )}

      {isEditable && (
        <Button
          variant="outlined"
          startIcon={<CloudUploadIcon />}
          component="label"
        >
          {file ? "Change File" : "Upload File"}
          <input
            type="file"
            hidden
            onChange={(e) => e.target.files[0] && onChange(e.target.files[0])}
          />
        </Button>
      )}
    </Box>
  );
}
